import { render, staticRenderFns } from "./ServiceAboutPage.vue?vue&type=template&id=30ef4da6&scoped=true&"
import script from "./ServiceAboutPage.vue?vue&type=script&lang=js&"
export * from "./ServiceAboutPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAboutPage.vue?vue&type=style&index=0&id=30ef4da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef4da6",
  null
  
)

export default component.exports